var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btns" },
    [
      _vm._l(_vm.button, function(item) {
        return [
          item.key === "importFormConfig"
            ? _c(
                "el-upload",
                {
                  key: item.key,
                  staticClass: "upload-form-config",
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px"
                  },
                  attrs: {
                    accept: ".zip",
                    action: _vm.baseUrl + "/formConfig/import",
                    headers: {
                      Authorization: _vm.token
                    },
                    "on-progress": _vm.handleLoading,
                    "on-success": _vm.handleLoadingClose,
                    multiple: "",
                    limit: 3
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      style: {
                        fontSize: _vm.fonts,
                        fontFamily: _vm.family,
                        fontWeight: _vm.weight
                      },
                      attrs: {
                        loading: _vm.loading,
                        size: _vm.size,
                        type: "primary"
                      }
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                ],
                1
              )
            : _c(
                "el-button",
                {
                  key: item.key,
                  style: {
                    fontSize: _vm.fonts,
                    fontFamily: _vm.family,
                    fontWeight: _vm.weight
                  },
                  attrs: {
                    loading: _vm.loading,
                    size: _vm.size,
                    type: "primary",
                    icon: item.icon,
                    disabled: item.disabled
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleClickButton(item.key, item.label)
                    }
                  }
                },
                [_vm._v(_vm._s(item.label))]
              )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }